import type { FunctionComponent } from 'react';
import { useCallback, useRef } from 'react';
import { FormattedMessage } from 'react-intl';

import { wait } from '@trello/time';

interface FileLinkComponentProps {
  url: string;
}

export const FileLinkComponent: FunctionComponent<FileLinkComponentProps> = ({
  url,
}) => {
  const inputEl = useRef<HTMLInputElement>(null);

  // Automatically select the text in the input when the user clicks into it
  // but we need to defer the select call due to default browser behavior.
  const onClick = useCallback(async () => {
    await wait(0);
    inputEl.current?.select();
  }, []);

  return (
    <div>
      <p>
        <FormattedMessage
          id="templates.file_link_handler.browsers-prevent-file-links"
          defaultMessage="You can view this link by pasting the URL into a new tab"
          description="Text displayed to instruct users on how to view the file link"
        />
        <input
          type="text"
          ref={inputEl}
          value={url}
          readOnly={true}
          className="js-autofocus"
          onClick={onClick}
        />
      </p>
    </div>
  );
};
